import $ from 'jquery'
import { hideAll as hideAllTippys } from 'tippy.js'
import { handleDataFocus } from '~/common/behaviors/form_focus'

// options.append: append the content to the modal container instead of replacing it
//                 In an ideal world, we would not have modals that open on top of other modals. But that's not the case for some things right now.
//                 Moreover, we only allow modals-on-top-of-other-modals for 2-level. After which we start replacing the last modal.
//                 This works fine for most use-cases but for things like multi-level object picker where there can be multiple levels of nested modals, things break.
//                 In those cases, we want to allow appending the modal to the existing modal conainer instead of replacing the last modal with the new one.
export const showModal = (content, options = { append: false }) => {
  try {
    hideAllTippys()
  } catch (e) {
    console.error('showModal -> hideAllTippys failed', e)
  }

  const useModernModals =
    $(content).find('.t-modal').addBack().filter('.t-modal').length > 0

  let container = $(
    useModernModals ? '#tw-modal-container-ajax' : '#modal-container-ajax'
  )
  if (container.find('.modal, .t-modal').hasClass('in')) {
    container = $(
      useModernModals ? '#tw-modal-container-ajax-2' : '#modal-container-ajax-2'
    )
  }

  const existingModals = container.find('.modal, .t-modal')

  const $el = options.append
    ? container.append(content)
    : container.html(content)

  container.changed()

  const newModal = $el
    .find('.modal, .t-modal')
    .toArray()
    .find((el) => !existingModals.is(el))

  if (useModernModals) {
    raiseAboveOpenModals(newModal)
    const deferredShow = () => {
      newModal.modal
        ? newModal.modal('show')
        : setTimeout(() => deferredShow(), 100)
    }
    setTimeout(deferredShow, 0)
    return newModal
  }

  // Legacy modals - bootstrap/jquery - only on admin
  return $(newModal).modal({ backdrop: 'static' })
}

// ModalComponents all sit at z-[99999] and stack by DOM order, and these AJAX containers come
// before the page's own dialogs. So a modal fetched from inside an open one (SMS pricing from
// Send text message) would open underneath it. Lift it above every open one, as the
// show.bs.modal handler below does for Bootstrap modals.
const raiseAboveOpenModals = (modal) => {
  if (!modal) return
  const openLayers = [
    ...document.querySelectorAll('.t-modal-content-outer'),
  ].filter((el) => !modal.contains(el) && !el.classList.contains('hidden'))
  if (openLayers.length === 0) return

  const top = Math.max(
    ...openLayers.map(
      (el) => parseInt(window.getComputedStyle(el).zIndex, 10) || 0
    )
  )
  modal
    .querySelectorAll(
      ':scope > [data-modal-target=backdrop], :scope > [data-modal-target=contentContainer]'
    )
    .forEach((el) => {
      el.style.zIndex = String(top + 1)
    })
}

// CALVIN: I really dislike this. We should not have modals that open on top of other modals.
// Whenever this happens, we need to rethink the UI.
// If you spot such a case, let me know about it so we can come up with a better solution
$(document).on('show.bs.modal', '.modal', function () {
  // Heavily from https://stackoverflow.com/questions/19305821/multiple-modals-overlay
  // One addition is the paddingTop
  const visibleModals = $('.modal:visible').length
  let zIndexOfVisibleModal = 0
  $('.modal:visible').map((i, elm) => {
    const elmZIndex = parseInt($(elm).css('z-index') || 0)
    if (elmZIndex > zIndexOfVisibleModal) {
      zIndexOfVisibleModal = elmZIndex
    }
  })
  const visibleDropdowns = $('.js-dropdown-content-container:visible').length
  // Only count Tailwind modals that are actually open. The `.t-modal` wrapper is a
  // static block that stays in the DOM even when closed (e.g. #modal-chat, #pip-modal),
  // so `.t-modal:visible` matched those empty shells and bumped every Bootstrap modal by
  // +99999 unconditionally — pushing a modal that contains a TinyMCE editor above the
  // editor's own dialogs (source code, etc.), which live at z-100000 (ENG-30866). The
  // fixed full-screen `.t-modal-content-outer` overlay is `hidden` until the modal opens,
  // so it is `:visible` only for genuinely-shown modals.
  const visibleTailwindModals = $('.t-modal-content-outer:visible').length
  const zIndex =
    1050 +
    (10 + zIndexOfVisibleModal) +
    (visibleDropdowns ? 9999 : 0) +
    // Clear Tailwind .t-modal modals, which sit at z-[99999] (modal_component.html.erb)
    (visibleTailwindModals ? 99999 : 0)
  const paddingTop = Math.min(30 * visibleModals, 100)
  $(this).css('z-index', zIndex).css('padding-top', paddingTop)
  setTimeout(() => {
    $('.modal-backdrop')
      .not('.modal-stack')
      .css('z-index', zIndex - 1)
      .addClass('modal-stack')
    $('.modal-backdrop').first().addClass('base-modal-backdrop')
  })
})

$(document).on('shown.bs.modal', '.modal', function () {
  // CustomView action forms are inside the node, not outside
  const form = this.closest('form') || this.querySelector('form')
  if (form) {
    setTimeout(() =>
      handleDataFocus(form.querySelector('[data-focus]') || form)
    )
  }
})

$(document).on(
  'hidden.bs.modal',
  '.modal',
  () => $('.modal:visible').length && $(document.body).addClass('modal-open')
)
